module.exports = __webpack_public_path__ + "img/3C-banner.7d5edc55.png";